import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { MethodNewsInterface } from '../../+models';
import { MethodNewsActions, MethodNewsActionTypes } from './method-news.actions';

export const NAME = 'methodNews';

export interface State extends EntityState<MethodNewsInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<MethodNewsInterface> = createEntityAdapter<MethodNewsInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: MethodNewsActions): State {
  switch (action.type) {
    case MethodNewsActionTypes.MethodNewsLoaded: {
      return adapter.setAll(action.payload.methodNews, { ...state, loaded: true });
    }

    case MethodNewsActionTypes.MethodNewsLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case MethodNewsActionTypes.ClearMethodNews: {
      return adapter.removeAll(state);
    }

    case MethodNewsActionTypes.AddMethodNews: {
      return adapter.addMany(action.payload.methodNews, state);
    }

    case MethodNewsActionTypes.SetMethodNewsForNews: {
      const { newsId, methodNews } = action.payload;

      const toRemove = (state.ids as number[]).filter((id) => {
        const entity = state.entities[id];
        return entity.newsId === newsId;
      });

      const clearedState = adapter.removeMany(toRemove, state);
      const newState = adapter.addMany(methodNews, clearedState);

      return newState;
    }

    case MethodNewsActionTypes.RemoveMethodNewsForNews: {
      const { newsId } = action.payload;

      const toRemove = (state.ids as number[]).filter((id) => {
        const entity = state.entities[id];
        return entity.newsId === newsId;
      });
      return adapter.removeMany(toRemove, state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
